import React, { useContext } from 'react';
import { Button } from 'antd';

import ButtonCreateStaticActivity from '@totem/components/ticketing/details/activities/buttonCreateStaticActivity';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNull } from '@totem/utilities/common';

const styles = {
  button: {
    fontSize: '36px',
    marginLeft: '0.5em',
  },
};

type Props = {
  buttonProps?: Omit<
    React.ComponentProps<typeof Button>,
    'onClick' | 'disabled' | 'children'
  >;
};

const CancelButton = ({ buttonProps }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const { ticket, activityConfiguration } = useContext(TicketContext);

  if (
    !permissions.internal.hasPermissions(userProfile) ||
    isNull(activityConfiguration) ||
    activityConfiguration.findIndex(
      (chk) => chk.id === '00000085f3399dc06f000001', // Code == CLOSE
    ) === -1 ||
    isNull(ticket) ||
    ticket.ticket.subCategory !== 'Opportunity'
  ) {
    return null;
  }

  return (
    <div style={styles.button}>
      <ButtonCreateStaticActivity
        activityId={'00000085f3399dc06f000001'}
        title={'Cancel'}
        buttonProps={buttonProps}
      />
    </div>
  );
};

export default CancelButton;
